import { useMemo } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import {getStaticPageListapi } from './Components/Redux/Globalslice';
import { useDispatch } from 'react-redux';
import './Home.css';
import './Whoweare.css';
import './Media.css';
import Approute from './Components/Approutes/Approute';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
    const dispatch = useDispatch();
    useMemo(() => {
    dispatch(getStaticPageListapi());

  }, [dispatch]);
  return (
    <div className='globalbody' >
       <ToastContainer position="top-right" autoClose={3000} />
      <Approute />
    </div>
  );
}
export default App;
